import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box
} from "@mui/material";

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function LeaguesPage() {
  const fields = [
    { title: "Title", name: "title" },
    { title: "League Type", name: "league_type" }
  ];
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const [leagues, setLeagues] = useState([]);

  useEffect(() => getData(), []);

  const getData = () => {
    setLoading(true);

    const fetchDataOverallLeagues = async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leagues`
      );
      setRows(data.leagues);
      return data;
    };

    const fetchDataFriendsLeagues = async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/friends`
      );
      setLeagues(data.leagues);
      return data;
    };

    Promise.all([
      fetchDataOverallLeagues(),
      fetchDataFriendsLeagues(),
    ])
      .then(() => {})
      .finally(() => setLoading(false));
  }

  return (
    <>
      <Helmet>
        <title> Leagues </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Leagues
          </Typography>
          {
            !rows.length && (
              <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => navigate("/dashboard/new-league")}
            >
              Create Overall League
            </Button>
            )
          }
        </Stack>
        <Card>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      {fields.map((field) => (
                        <TableCell key={field.name}>{field.title}</TableCell>
                      ))}
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {fields.map((field) => (
                          <TableCell key={field.name}>
                            {row[field.name]}
                          </TableCell>
                        ))}
                        <TableCell>
                          <Iconify
                            icon={"eva:edit-outline"}
                            sx={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                `/dashboard/edit-league?league_id=${row.league_id}`
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                    {leagues.map((league, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {fields.map((field) => (
                          <TableCell key={field.name}>
                            {league[field.name]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
